import { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { colors } from 'settings/colors'
import { captureFrontendError } from 'utils/captureFrontendError'
import { mapApiDeviceVendorToLabel } from './mapApiDeviceVendorToLabel'

const NelsonTwigIcon = (props: { color: string }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 29.5C23.0081 29.5 29.5 23.0081 29.5 15C29.5 6.99187 23.0081 0.5 15 0.5C6.99187 0.5 0.5 6.99187 0.5 15C0.5 23.0081 6.99187 29.5 15 29.5Z"
      fill={colors.grey200}
      stroke="#D9D9D9"
    />
    <circle cx="15" cy="15" r="13" fill={props.color} stroke="white" strokeWidth="2" />
    <path
      d="M8.46528 17.4987H8V8.03426L22 8V9.85337H19.6548C19.4795 9.85337 19.3171 9.94516 19.2266 10.0953L15.9939 15.4595C15.7839 15.808 15.2676 15.773 15.1065 15.3993L13.3453 11.3123C13.1837 10.9371 12.6647 10.9037 12.4562 11.2549L8.89524 17.2539C8.80516 17.4057 8.64176 17.4987 8.46528 17.4987Z"
      fill="white"
    />
    <path
      d="M8.92027 19.6241H8.00977V22.0383H22.0098V11.9082H20.6797C20.5039 11.9082 20.3411 12.0005 20.2507 12.1513L15.7702 19.6331C15.5648 19.9761 15.0597 19.9512 14.889 19.5895L12.9241 15.4241C12.7585 15.0731 12.2737 15.0363 12.0571 15.3583L9.33509 19.4032C9.24218 19.5413 9.08668 19.6241 8.92027 19.6241Z"
      fill="white"
    />
  </svg>
)

const nelsonTwigIconAsString = `
  <svg width="30" height="30" viewBox="0 0 30 30">
    <path
      d="M15 29.5C23.0081 29.5 29.5 23.0081 29.5 15C29.5 6.99187 23.0081 0.5 15 0.5C6.99187 0.5 0.5 6.99187 0.5 15C0.5 23.0081 6.99187 29.5 15 29.5Z"
      fill="${colors.grey200}"
      stroke="#D9D9D9"
    />
    <circle cx="15" cy="15" r="13" fill="${colors.midnight}" stroke="white" stroke-width="2" />
    <path
      d="M8.46528 17.4987H8V8.03426L22 8V9.85337H19.6548C19.4795 9.85337 19.3171 9.94516 19.2266 10.0953L15.9939 15.4595C15.7839 15.808 15.2676 15.773 15.1065 15.3993L13.3453 11.3123C13.1837 10.9371 12.6647 10.9037 12.4562 11.2549L8.89524 17.2539C8.80516 17.4057 8.64176 17.4987 8.46528 17.4987Z"
      fill="white"
    />
    <path
      d="M8.92027 19.6241H8.00977V22.0383H22.0098V11.9082H20.6797C20.5039 11.9082 20.3411 12.0005 20.2507 12.1513L15.7702 19.6331C15.5648 19.9761 15.0597 19.9512 14.889 19.5895L12.9241 15.4241C12.7585 15.0731 12.2737 15.0363 12.0571 15.3583L9.33509 19.4032C9.24218 19.5413 9.08668 19.6241 8.92027 19.6241Z"
      fill="white"
    />
  </svg>
  `

const AltracIcon = (props: { color: string }) => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0137 29.5C23.0218 29.5 29.5137 23.0081 29.5137 15C29.5137 6.99187 23.0218 0.5 15.0137 0.5C7.00554 0.5 0.513672 6.99187 0.513672 15C0.513672 23.0081 7.00554 29.5 15.0137 29.5Z"
      fill={colors.grey200}
      stroke="#D9D9D9"
    />
    <circle cx="15.0137" cy="15" r="13" fill={props.color} stroke="white" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2158 19.5932C17.3053 20.3418 16.1729 20.7991 14.9465 20.8403C11.9643 20.9405 9.51367 18.2544 9.51367 14.8929C9.51367 11.6383 11.9475 9 14.9497 9C17.952 9 20.3858 11.6383 20.3858 14.8929C20.3858 14.9156 20.3857 14.9383 20.3855 14.9609V20.6051H18.2158V19.5932ZM18.2238 14.9626C18.2238 17.0591 16.8607 18.762 14.9267 18.762C12.9926 18.762 11.4902 17.0591 11.4902 14.9626C11.4902 12.866 13.1345 11.2517 14.931 11.3091C16.865 11.3091 18.2238 13.1184 18.2238 14.9626Z"
      fill="white"
    />
  </svg>
)

const altracIconAsString = `
  <svg width="31" height="30" viewBox="0 0 31 30">
    <path
      d="M15.0137 29.5C23.0218 29.5 29.5137 23.0081 29.5137 15C29.5137 6.99187 23.0218 0.5 15.0137 0.5C7.00554 0.5 0.513672 6.99187 0.513672 15C0.513672 23.0081 7.00554 29.5 15.0137 29.5Z"
      fill="${colors.grey200}"
      stroke="#D9D9D9"
    />
    <circle cx="15.0137" cy="15" r="13" fill="${colors.midnight}" stroke="white" stroke-width="2" />
    <path
      style="fill-rule: evenodd"
      d="M18.2158 19.5932C17.3053 20.3418 16.1729 20.7991 14.9465 20.8403C11.9643 20.9405 9.51367 18.2544 9.51367 14.8929C9.51367 11.6383 11.9475 9 14.9497 9C17.952 9 20.3858 11.6383 20.3858 14.8929C20.3858 14.9156 20.3857 14.9383 20.3855 14.9609V20.6051H18.2158V19.5932ZM18.2238 14.9626C18.2238 17.0591 16.8607 18.762 14.9267 18.762C12.9926 18.762 11.4902 17.0591 11.4902 14.9626C11.4902 12.866 13.1345 11.2517 14.931 11.3091C16.865 11.3091 18.2238 13.1184 18.2238 14.9626Z"
      fill="white"
    />
  </svg>
  `

const WiseconnIcon = (props: { color: string }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 29.5C23.0081 29.5 29.5 23.0081 29.5 15C29.5 6.99187 23.0081 0.5 15 0.5C6.99187 0.5 0.5 6.99187 0.5 15C0.5 23.0081 6.99187 29.5 15 29.5Z"
      fill={colors.grey200}
      stroke="#D9D9D9"
    />
    <circle cx="15" cy="15" r="13" fill={props.color} stroke="white" strokeWidth="2" />
    <path
      d="M20.6429 13.8432C19.6315 11.5543 17.1368 7.70327 15.1615 5.44434C14.6506 6.01935 13.1861 7.93561 12.8418 8.49447C14.2789 10.424 16.2084 12.5796 17.0965 14.2104C17.7856 15.4759 18.364 16.4629 18.0491 17.6093C18.582 17.1088 20.3662 14.4446 20.6429 13.8432Z"
      fill="white"
    />
    <path
      d="M14.8542 11.8252L12.5518 8.91699C10.9471 11.3224 8.69141 14.8651 8.69141 17.2022C8.69141 20.9729 11.8005 22.7933 13.1981 23.1758C12.8587 22.3168 12.0657 18.8779 12.1776 16.801C12.2365 15.7091 13.6828 13.2391 14.8542 11.8252Z"
      fill="white"
    />
    <path
      d="M12.6858 18.4878C12.7776 19.4265 13.4463 22.4098 13.7071 23.3281C17.2788 24.2639 20.2746 21.512 20.922 20.0831C21.8381 18.2555 21.8611 16.6029 20.8873 14.4118C20.125 15.6752 17.8693 19.8014 15.1512 19.8014C14.7079 19.8014 13.4434 19.5876 12.6858 18.4878Z"
      fill="white"
    />
  </svg>
)

const wiseconnIconAsString = `<svg width="30" height="30" viewBox="0 0 30 30">
    <path
      d="M15 29.5C23.0081 29.5 29.5 23.0081 29.5 15C29.5 6.99187 23.0081 0.5 15 0.5C6.99187 0.5 0.5 6.99187 0.5 15C0.5 23.0081 6.99187 29.5 15 29.5Z"
      fill="${colors.grey200}"
      stroke="#D9D9D9"
    />
    <circle cx="15" cy="15" r="13" fill="${colors.midnight}" stroke="white" stroke-width="2" />
    <path
      d="M20.6429 13.8432C19.6315 11.5543 17.1368 7.70327 15.1615 5.44434C14.6506 6.01935 13.1861 7.93561 12.8418 8.49447C14.2789 10.424 16.2084 12.5796 17.0965 14.2104C17.7856 15.4759 18.364 16.4629 18.0491 17.6093C18.582 17.1088 20.3662 14.4446 20.6429 13.8432Z"
      fill="white"
    />
    <path
      d="M14.8542 11.8252L12.5518 8.91699C10.9471 11.3224 8.69141 14.8651 8.69141 17.2022C8.69141 20.9729 11.8005 22.7933 13.1981 23.1758C12.8587 22.3168 12.0657 18.8779 12.1776 16.801C12.2365 15.7091 13.6828 13.2391 14.8542 11.8252Z"
      fill="white"
    />
    <path
      d="M12.6858 18.4878C12.7776 19.4265 13.4463 22.4098 13.7071 23.3281C17.2788 24.2639 20.2746 21.512 20.922 20.0831C21.8381 18.2555 21.8611 16.6029 20.8873 14.4118C20.125 15.6752 17.8693 19.8014 15.1512 19.8014C14.7079 19.8014 13.4434 19.5876 12.6858 18.4878Z"
      fill="white"
    />
  </svg>`

const reportedUnknownVendorNames = new Set<string>()

export const mapApiDeviceVendorToUiItems = (
  deviceVendor: SharedTypes.IrrigationScheduler.EIrrigationVendorName,
) => {
  switch (deviceVendor) {
    case SharedTypes.IrrigationScheduler.EIrrigationVendorName.altrac: {
      return {
        label: mapApiDeviceVendorToLabel(deviceVendor),
        Icon: AltracIcon,
        iconAsString: altracIconAsString,
      }
    }

    case SharedTypes.IrrigationScheduler.EIrrigationVendorName.nelson: {
      return {
        label: mapApiDeviceVendorToLabel(deviceVendor),
        Icon: NelsonTwigIcon,
        iconAsString: nelsonTwigIconAsString,
      }
    }

    case SharedTypes.IrrigationScheduler.EIrrigationVendorName.wiseconn: {
      return {
        label: mapApiDeviceVendorToLabel(deviceVendor),
        Icon: WiseconnIcon,
        iconAsString: wiseconnIconAsString,
      }
    }

    default: {
      deviceVendor satisfies never

      if (!reportedUnknownVendorNames.has(deviceVendor)) {
        reportedUnknownVendorNames.add(deviceVendor)

        captureFrontendError(`IrrigationVendorName "${deviceVendor}" has not been implemented`)
      }

      return { label: deviceVendor, Icon: null }
    }
  }
}
